<div class="container">
  <app-board></app-board>
</div>

<ng-adsense
  [adSlot]="2103322260"
  [width]="728"
  [height]="90"
>